import React from 'react';
import './helpstyle.css';
import { Link } from 'react-router-dom';




const PageTwo = () => {
  return (
    <div>
      <div className="header w-100 d-flex justify-content-between mt-0">
        <img src="/img/logos/logo.png" alt="logo" className="ms-3 ms-md-5 my-3" />
        <button  type="button" className="btn btnhelp text-light float-end my-2 me-3 me-md-5">
          <Link to="/" className="d-block">
          بازگشت
            </Link>
        </button>
      </div>

      <div className="container" style={{ marginTop: '100px' }}>
        <div className="d-flex flex-column justify-content-center align-items-center mt-3">
          <img src="./img/logos/logo.png" style={{ width: '100px' }} alt="logo" />
          <div className="text-center w-75 mt-3 fw-bold">
            نحوه استفاده بهینه از نرم افزار چیدمان هوشمند
          </div>
        </div>
      </div>

      <div className="box1 bg-light rounded-4 mx-2 mx-md-5 mt-4 p-3">
        <div className="row">
          <div className="col-12 col-sm-6 order-1 order-sm-0 align-self-center fw-bold">
            1. پس از وارد شدن به نرم افزار چیدمان با کلیک بر روی گزینه ی انتخاب تصویر از گالری خود یا با انتخاب
            دوربین از محیط مد نظر خود عکس بگیرید.
          </div>

          <div className="col-12 col-sm-6 order-0 order-sm-1">
            <img src="./img/Group 14.png" className="w-100 img-fluid d-none d-sm-block" alt="img" />
            <img src="./img/Group 27.png" className="w-100 img-fluid d-sm-none" alt="img" />
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-12 col-sm-6">
            <img src="./img/Frame 1.png" className="w-100 img-fluid d-none d-sm-block" alt="img" />
            <img src="./img/Group 24.png" className="w-100 img-fluid d-sm-none" alt="img" />
          </div>

          <div className="col-12 col-sm-6 align-self-center fw-bold">
            2. با انتخاب دایره های موجود در تصویر کف یا دیوار مورد نظر خود را انتخاب کنید.
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-12 col-sm-6 order-1 order-sm-0 align-self-center fw-bold">
            3. از قسمت محصولات مدل مورد نظر خود را انتخاب کرده و ان را در فضای خود مشاهده کنید.
          </div>

          <div className="col-12 col-sm-6 order-0 order-sm-1">
            <img src="./img/Frame 11.png" className="w-100 img-fluid d-none d-sm-block" alt="img" />
            <img src="./img/Group 25.png" className="w-100 img-fluid d-sm-none" alt="img" />
          </div>
        </div>
      </div>

      <img src="./img/Frame 111111.png" className="w-100 img-fluid mt-2 d-none d-sm-block" alt="" />
      <div className="d-flex flex-column just align-items-center ">
        <img src="./img/Group 133333.png" className="w-75 mt-3 align-items-center d-sm-none img-fluid" alt="" />
        <img src="./img/Frame 12.png" className="w-100 img-fluid d-sm-none" alt="" />
      </div>
    </div>
  );
};

export default PageTwo;
